<script lang="ts">
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'
    import Category from './Category.svelte'

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider
</script>

<Category {serviceProvider} {dataProvider}/>
